import { Injectable } from '@angular/core';
import { showToast } from 'onevedai-ui/show-toast';

export interface SnackBarConfig {
  duration?: number;
  variant?: 'default' | 'success' | 'error' | 'warning';
}

/** Drop-in for MatSnackBar.open(message, action?, config?) on top of the OneVedAI UI toast. */
@Injectable({ providedIn: 'root' })
export class SnackBarService {
  open(message: string, action?: string, config: SnackBarConfig = {}): void {
    showToast({
      message,
      variant: config.variant ?? this.guessVariant(message),
      duration: config.duration ?? 4000,
      ...(action && action.toLowerCase() !== 'close' ? { actionLabel: action } : {}),
    });
  }

  private guessVariant(message: string): 'default' | 'success' | 'error' {
    const m = message.toLowerCase();
    if (/(fail|error|unable|invalid|denied|cannot|could not|not found|required|please select|please add)/.test(m)) return 'error';
    if (/(success|created|updated|saved|deleted|added|exported|generated|sent|removed)/.test(m)) return 'success';
    return 'default';
  }
}
